import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Dashboard.css';

const Dashboard = () => {
  const { user } = useAuth();

  return (
    <div className="container">
      <div className="dashboard-hero">
        <h1>Welcome back, {user?.name || user?.email}!</h1>
        <p className="hero-subtitle">Discover, summarize, and organize your favorite books</p>
      </div>

      <div className="dashboard-grid">
        <Link to="/search" className="dashboard-card">
          <div className="card-icon">🔍</div>
          <h2>Search Books</h2>
          <p>Find books from millions of titles and get AI-powered summaries</p>
        </Link>

        <Link to="/saved" className="dashboard-card">
          <div className="card-icon">📚</div>
          <h2>Saved Books</h2>
          <p>View your collection of saved books</p>
        </Link>

        <Link to="/summaries" className="dashboard-card">
          <div className="card-icon">📝</div>
          <h2>My Summaries</h2>
          <p>Access all your AI-generated book summaries</p>
        </Link>

        <Link to="/questions" className="dashboard-card">
          <div className="card-icon">❓</div>
          <h2>My Questions</h2>
          <p>View all your questions and answers about books</p>
        </Link>
      </div>
    </div>
  );
};

export default Dashboard;
